import { plainObject } from '../interfaces/plain-obj';
import { PlantDetailsHeaderVal } from '../interfaces/plant-details-header-val';
import { TOKEN_KEYS } from '../models/enum';
import { getMonthNameByMonth } from '../utils/date_utils';

export const sharedheaderKeyMap: plainObject = {
  totalPlants: 'Total Plant',
  plantsOnline: 'Online',
  plantsOffline: 'Offline',
  plantsInstalledLastMonth: 'Last Month',
  plantsInstalledThisMonth: 'This Month',
  notification: 'Notification',
  plantName: 'Plant Name',
  modelName: 'Model Name',
  importance: 'Importance',
  dataLogger: 'Data Logger',
  ocurred: 'Ocurred',
  resolved: 'Resolved',
};

export const plantDetailsHeaderData: Array<PlantDetailsHeaderVal> = [
  {
    icon: 'assets/svg/total_plants.svg',
    description: 'Total Plant',
    value: 88,
  },
  {
    icon: 'assets/svg/online_plants.svg',
    description: 'Online',
    value: 99,
  },
  {
    icon: 'assets/svg/offline_plants.svg',
    description: 'Offline',
    value: 22,
  },
  {
    icon: 'assets/svg/circle.svg',
    description: 'Last Month',
    overlayIcon: 'assets/svg/calendar.svg',
    overlayString: getMonthNameByMonth(new Date().getMonth()),
    value: 33,
  },
  {
    icon: 'assets/svg/circle.svg',
    description: 'This Month',
    overlayIcon: 'assets/svg/calendar.svg',
    overlayString: getMonthNameByMonth(new Date().getMonth() + 1),
    value: 44,
  },
];

export const alertHeaders: Array<string> = [
  'Plant Name',
  'Alerts',
  'Type',
  'Model Name',
  'Datalogger',
  'Occured',
  'Resolved',
  'Customer Details',
];

export const lifetimeSavings = "lifetimeSavings";
export const INR_THOUSAND = 1000;
export const INR_LAKH = 100 * INR_THOUSAND;
export const INR_CRORE = 100 * INR_LAKH;

export const forgetPasswordScreen=
{
validEmail:"Email must be a valid Email Address",
otpLength:"OTP code must be 6 characters long",
passwordTypeDescriptionLength:"Password must be at least 8 characters long and should have a combination of one uppercase letter,one lowercase letter ,one special character , and one number ",
passwordLength:"Password must be at least 8 characters long",
passwordTypeDescription:" Password must have one uppercase letter,one lowercase letter, one special character, and one number.",
otpExpiredMessage:"OTP expired. Please resend to try again.",
otpSendMessage:"Verification code sent to your email"
}
export const siteIds={
  "haridwarSiteId":82944,
  "rudrapurSiteId":808201,
  "baddiSiteId":1032256
 }

  export const plantTypeArray=[{
    'userName':'luminous@holmium.com',
    'password':'LUMINOUS',
    'token':TOKEN_KEYS.haridwar
  },{
    'userName':'Luminousrudrapur@holmium.com',
    'password':'LUMINOUSRUDRAPUR',
    'token':TOKEN_KEYS.rudrapur

  },{
    'userName':'Manish.kumar3@luminousindia.com',
    'password':'Holmium@2025',
    'token':TOKEN_KEYS.baddi
  }]
export const MONTHS = [
    { value: '01', label: '01' },
    { value: '02', label: '02' },
    { value: '03', label: '03' },
    { value: '04', label: '04' },
    { value: '05', label: '05' },
    { value: '06', label: '06' },
    { value: '07', label: '07' },
    { value: '08', label: '08' },
    { value: '09', label: '09' },
    { value: '10', label: '10' },
    { value: '11', label: '11' },
    { value: '12', label: '12' },
  ];